import React from 'react'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

import lighthouse from '../components/app-logo/assets/logo.svg'

// COMPONENTS
import AppBar from '../components/app-bar/AppBar'
import MuiLink from '@material-ui/core/Link'
import { ButtonContained } from '../components/app-button/button'

const style = theme => ({
  h6: {
    fontSize: 24,
    fontWeight: 'bold',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: '-0.5px',
    textAlign: 'center',
    color: '#000000',
  },
  link: {
    fontSize: 24,
    letterSpacing: '-0.5px',
    textAlign: 'center',
    color: '#8866ff',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  steps: {
    margin: '34px 0',
    padding: 0,
    textAlign: 'left',
    listStyleType: 'none',
  },
  contentRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  content: {
    maxWidth: '100vmin',
    margin: '20px auto',
    paddingLeft: theme.spacing.unit * 2,
    paddingRight: theme.spacing.unit * 2,
    textAlign: 'center',
  },
  title: {
    fontSize: '8vmin',
    fontWeight: 700,
    letterSpacing: 1,
    textAlign: 'center',
    color: '#000000',
  },
  subTitle: {
    fontSize: '3vmin',
    marginTop: 34,
    letterSpacing: 5,
    textAlign: 'center',
    textTransform: 'uppercase',
  },
  lighthouse: {
    margin: '28px 0',
    height: '30vmin',
  },
  stepInfo: {
    paddingLeft: 10,
  },
  linkInButton: {
    textDecoration: 'none',
  },
})

const steps = [
  'Делаем сначала то-то, и это просто сделать',
  'Делаем потом то-то – это еше проще',
  'профит',
]

const Home = ({ classes }) => {
  // eslint-disable-next-line no-script-url
  const dudUrl = 'javascript:;'

  const { user } = window.state
  const islogin = user ? true : false

  return (
    <section className={classes.pageTemplate}>
      <AppBar islogin={islogin} />

      <main className={classes.content}>
        <Typography variant="h1" gutterBottom className={classes.title}>
          Детальная аналитика бла-бла-ленд
        </Typography>
        <Typography
          variant="subtitle1"
          gutterBottom
          className={classes.subTitle}
        >
          Сделай все правильно – и оно полетит
        </Typography>
        <img src={lighthouse} className={classes.lighthouse} alt={lighthouse} />
        <div className={classes.contentRow}>
          <Typography variant="h6" className={classes.h6}>
            В двух словах
          </Typography>
          <Typography>
            <MuiLink
              underline={'always'}
              to={dudUrl}
              color="secondary"
              className={classes.link}
            >
              Покажите подробности!
            </MuiLink>
          </Typography>
        </div>
        <ul className={classes.steps}>
          {steps.map((step, i) => {
            return (
              <li key={'step-' + i} className={classes.step}>
                {i + 1}.<span className={classes.stepInfo}>{step}</span>
              </li>
            )
          })}
        </ul>
        <a
          href={islogin ? '/dashboard' : '/register'}
          className={classes.linkInButton}
        >
          <ButtonContained
            color="primary"
            style={{
              width: '100%',
              padding: '24px 0',
            }}
            text={'Подключиться бесплатно'}
          />
        </a>
      </main>
    </section>
  )
}

export default withStyles(style)(Home)
